(function($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var $body = $('body');
    var winST = $win.scrollTop();
    var lastWinST = 0;

    /*
     *   Is Mobile
     */
    function isMobile() {
        return $win.width() < 768;
    }

    /*
     *   Is Tablet
     */
    function isTablet() {
        return $win.width() < 1024;
    }

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == 'number') myWidth = window.innerWidth;
        else if (
            document.documentElement &&
            document.documentElement.clientWidth
        )
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == 'number')
            myHeight = window.innerHeight;
        else if (
            document.documentElement &&
            document.documentElement.clientHeight
        )
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }

    function animateHeader(winST) {
        var headerHeight = $('.js-header').outerHeight();
        var winHeight = !isMobile() ? $win.outerHeight() : $win[0].innerHeight;

		if ( ! isTablet() ) {
			headerHeight = headerHeight - 50;
		}

        // if ( $win.width() >= 1200 ) {
        //  var headerHeight = $('.header .header__bar').outerHeight() + $('.header .header__body').outerHeight();
        // }
        //

        $('.header').toggleClass('is-hidden is-fixed', winST > headerHeight);
        $('.header').toggleClass('is-visible', winST > headerHeight * 2);
        // setTimeout(function() {}, 500);
    }

	var $calc = $('.calculator__form');
	var $calc_wrapper = $calc.find('.categories');
	var $calc_head = $calc.find('.categories__head');

	function fixed_calc_header(winST) {
		if ($calc.length > 0) {
			var headerHeight = $('.js-header').outerHeight();
			var calc_head_pos = $calc_wrapper.offset().top;

			var is_fixed = winST + headerHeight > calc_head_pos ? true : false;

			$calc.toggleClass('head-is-fixed', is_fixed);

			$calc_head.css('top', is_fixed ? headerHeight : 0);
			$calc_wrapper.css('padding-top', is_fixed ? $calc_head.outerHeight() : 0);

			// setTimeout(function() {}, 500);
		}
	}

	function anchorLinks() {
        $("a[href^='#'], a[href^='/#']").not('.js-popup-modal, .js-popup-modal-delete').on( 'click', function(e) {
			var $this = $(this),
				href = $this.attr('href'),
				target = href.charAt(0) === '/' ? href.substring(1, href.length) : href,
				$target = $( target );

			if ( $target.length ) {
				e.preventDefault();

				if ( $('.js-header-aside').hasClass('is-active') ) {
					$('.js-nav-trigger').trigger('click');
				}

				var header_offset = 50;

				if ( isTablet() ) {
					header_offset = 45;
				}

				if ( isMobile() ) {
					header_offset = 30;
				}

				$('html, body').animate({
					scrollTop: $target.offset().top - header_offset,
				}, 400);
			}
		});
    }

    function initializeSliders() {
		var $element = $('.js-slider');

        if (!$element.length) {
            return false;
        }

        $element.each(function() {
            var $slider = $(this);
			var $sliderSlides = $slider.find('.js-slider-slides');

            // Get number of slides to show at specific browser widths. 0 = unslick.

            var showSlides = parseInt( $slider.attr('data-slidestoshow') );
            var showSlidesTablet = parseInt( $slider.attr('data-slidestoshow-tablet') );
            var showSlidesMobile = parseInt( $slider.attr('data-slidestoshow-mobile') );

			if ( isTablet() ) {
				showSlides = showSlidesTablet;
			}

			if ( isMobile() ) {
				showSlides = showSlidesMobile;
			}

			if ( showSlides === 0 ) {
				if ( $sliderSlides.hasClass('slick-initialized') ) {
					$sliderSlides.slick('unslick');
				}

				return;
			}

			if ( $sliderSlides.hasClass('slick-initialized') ) {
				return;
			}

			/* Additional Slider's data attributes to change plugin settings */

            var $sliderArrows = $slider.find('.js-slider-arrows');
            var $sliderDots = $slider.find('.js-slider-dots');

            var autoplaySlides =
                $slider.attr('data-autoplay') == 'true' ? true : false;
            var autoplayDelay = $slider.attr('data-autoplay-delay') || 5000;
            var autoHeight =
                $slider.attr('data-autoheight') == 'true' ? true : false;
            var loopSlides =
                $slider.attr('data-loop') == 'false' ? false : true;
            var centerSlides =
                $slider.attr('data-center') == 'true' ? true : false;

            var slidesWidth =
                $slider.attr('data-width') == 'false' ? true : false;

            var fadeSlides = $slider.attr('data-fade') == 'true' ? true : false;

            /* Plugin Settings */

            var settings = {
                arrows: true,
                appendArrows: $sliderArrows,
                prevArrow: $sliderArrows.find('.js-slider-arrow--prev'),
                nextArrow: $sliderArrows.find('.js-slider-arrow--next'),
                dots: true,
                appendDots: $sliderDots,
                infinite: loopSlides,
                slidesToShow: showSlides,
                adaptiveHeight: autoHeight,
                autoplay: autoplaySlides,
                centerMode: centerSlides,
                autoplaySpeed: autoplayDelay,
                speed: 400,
                touchMove: true,
                fade: fadeSlides,
                variableWidth: slidesWidth,
                cssEase: 'linear',
            };

            $sliderSlides.slick(settings);
        });
    }

    function videoPopup() {
        $('.js-popup-video').each(function(index, el) {
            $(this).magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                iframe: {
                    patterns: {
                        youtube_short: {
                            index: 'youtu.be/',
                            id: 'youtu.be/',
                            src: '//www.youtube.com/embed/%id%?autoplay=1',
                        },
                    },
                },
            });
        });
    }

    function modalPopup() {
        $('.js-popup-modal').each(function(index, el) {
            $(this).magnificPopup({
                type: 'inline',
                preloader: false,
                modal: true,
            });
        });

        $doc.on('click', '.popup-modal-dismiss', function(e) {
            e.preventDefault();

			if ( $( this ).hasClass( 'js-popup-create-cookie' ) ) {
				// Create cookie which expires at end of session.
				createCookie( $( this ).attr( 'data-popup-identifier' ), 'yes' );
			}

            $.magnificPopup.close();
        });
    }

    function fixedHeader() {
        var $header = $('.js-header');
        var $wrapper = $('.wrapper');

        $win.on('load resize', function() {
            var $headerHeight = $('.js-header').outerHeight();
            $wrapper.css({
                paddingTop: $headerHeight,
            });
        });
    }

    function changeBackgroundImage() {
        $('[data-image-desktop], [data-image-mobile]').each(function() {
            var $this = $(this);
            var url = $this.data('image-desktop');

            if (isMobile()) {
                if ($this.data('image-mobile')) {
                    url = $this.data('image-mobile');
                }
            }

            $this.css('background-image', 'url(' + url + ')');
        });
    }

    $('.js-nav-trigger').on('click', function(event) {
        $(this).toggleClass('is-active');
        $('.js-header-aside').toggleClass('is-active');
        $('.js-header .header__inner').toggleClass('is-active');
        $('body').toggleClass('is-fixed');
        event.preventDefault();
    });

    $('.js-tooltip-close').on('click', function(e) {
        e.preventDefault();

        $(this)
            .closest('.js-tooltip')
            .fadeOut();
    });

    $.fn.equalizeHeight = function(reset) {
        var maxHeight = 0,
            itemHeight,
			reset = typeof reset !== 'undefined' ? true : false;

        this.height('');

		if ( reset ) {
			return;
		}

        for (var i = 0; i < this.length; i++) {
            itemHeight = $(this[i])
                .height('auto')
                .height();
            if (maxHeight < itemHeight) {
                maxHeight = itemHeight;
            }
        }

        return this.height(maxHeight);
    };

    function widgetSwipe() {
		$body.on('swiped-left', '.widget', function(e) {
			$(this).addClass('is-active');
		});

		$body.on('swiped-right', '.widget', function(e) {
			$(this).removeClass('is-active');
		});
    }

    function categorySwipe() {
		$body.on('swiped-left', '.category .category__title.js-swipe', function(e) {
			$('.category__title.js-swipe.is-swiped').not(this).removeClass('is-swiped');
			$(this).addClass('is-swiped');
		});

		$body.on('swiped-right', '.category .category__title.js-swipe', function(e) {
			$(this).removeClass('is-swiped');
		});
    }

    function textEdit() {
		$body.on('click', '.js-text', function(e) {
			var $this = $(this);
			var $input = $this.siblings('.js-input');


			if ( ! $input.prop('readonly') ) {
				var value = $this.text();

				if ( $this.hasClass('money') ) {
					value = formatMoneyVal( $this.find('.money-value').text(), false );
				}

				$this.hide();
				$input.val( value );
				$input.attr( 'data-previous-value', value );

				$input.show().focus().select();
			} else {
				// Toggle open/close row when clicked text is not editable.
				$thisRowExpand = $this.closest('.category__cols').find('.category__col[data-col="expand"] .js-expand');

				if ( $thisRowExpand.length ) {
					$thisRowExpand.trigger('click');
				}
			}
		});

		$body.on('blur', '.js-input', function(e) {
			var $this    = $(this);
			var $text    = $this.siblings('.js-text');
			var value    = $this.val();
			var prev_val = $this.attr( 'data-previous-value' );

			$this.hide();

			if ( $text.hasClass('money') ) {
				value = formatMoneyVal( value );

				$text.find('.money-value').text( value );
			} else {
				$text.html( value );
			}

			$text.show();

			if ( typeof $this.attr('data-hidden-input') !== 'undefined' ) {
				var $hidden_input = $($this.attr('data-hidden-input'));

				if ( $hidden_input.length ) {
					if ( $hidden_input.is('[type="number"]') ) {
						value = formatMoneyVal( value, false );
					}

					$hidden_input.val( value );
				}
			}

			if ( prev_val === value ) {
				return;
			}

			if ( $this.closest('.popup-category').length ) {
				return;
			}

			if ( $this.hasClass('js-totals') ) {
				update_calc_row_money($this);
				update_calc_prices_r();
			} else {
				// Save calculator in background.
				save_calc( true );
			}

			// Save the current state.
			calc_state_save();
		});
    }

    function disableCategory() {
        $body.on('click', '.js-checkbox', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $category__cols = $this.closest('.category__cols');
			var target_class = $this.attr('data-target');

			$this
				.toggleClass('is-disable')
				.closest('.category')
				.toggleClass('disable')

			if ( typeof target_class !== 'undefined' && target_class.length > 0 ) {
				var $checkboxInput = $category__cols.find( target_class );

				if ( $checkboxInput.length ) {
					$checkboxInput.prop('checked', ! $this.hasClass('is-disable') );
				}
			}

			update_calc_prices_r();

			// Save the current state.
			calc_state_save();
        });
    }

    function expandCategory() {
        $body.on('click', '.js-expand', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $category__cols = $this.closest('.category__cols');
			var target_class = $this.attr('data-target');

			$this
				// .toggleClass('is-active')
				.closest('.category')
				.toggleClass('is-active')
				.find('.category__subitems')
				.eq(0)
				.stop()
				.slideToggle(600, function() {
					if ( typeof target_class !== 'undefined' && target_class.length > 0 ) {
						var $checkboxInput = $category__cols.find( target_class );

						if ( $checkboxInput.length ) {
							$checkboxInput.prop('checked', $this.closest('.category').hasClass('is-active') );
						}
					}

					// Save calculator in background.
					save_calc( true );

					// Save the current state.
					calc_state_save();
				});
		});
    }

    function deleteCategory() {
		$body.on('click', '.js-delete', function(e) {
			e.preventDefault();

            var $this_row   = $(this).closest('.category'),
            	$parent_row = $this_row.parents('.category').eq(0);

			$this_row.remove();

			if ( $parent_row.length ) {
				if ( $parent_row.find('> .category__subitems > .category').length < 1 ) {
					$parent_row.find('> .category__cols .toggle_with_children').toggleClass('hidden');
				}
			}

			update_calc_prices_r();
			update_calc_input_names_r();

			// Save the current state.
			calc_state_save();
		});
    }

    function cloneElement() {
		$body.on('click', '.js-clone', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $category = $this.parents('.category').eq(0);
			var $categoryParent = $category.parent();
			var $cloned = $category.clone();

			$categoryParent.append($cloned);

			update_calc_prices_r();
			update_calc_input_names_r();

			initializeSortables($cloned.find('.js-category-items'));

			// Save the current state.
			calc_state_save();
		});
    }

    function addSibling() {
		$body.on('click', '.js-add-sibling', function(e) {
			e.preventDefault();

			var $this        = $(this);
			var $thisRow     = $this.parents('.category').eq(0);
			var dataRowIndex = $thisRow.attr('data-row-type') === 'staff' ? 1 : 0;

			var $rowToClone = $('.calculator__blank-data .categories__body > .category').eq(dataRowIndex);

			if ( $rowToClone.length > 0 ) {
				var $cloned = $rowToClone.clone();

				$thisRow.after( $cloned );

				update_calc_prices_r();
				update_calc_input_names_r();

				initializeSortables($cloned.find('.js-category-items'));

				// Save the current state.
				calc_state_save();
			}
		});
    }

	function addRow() {
		$body.on('click', '.js-add-row', function(e) {
			e.preventDefault();

			var $this        = $(this);
			var $select      = $($this.attr('data-row-select'));
			var dataRowIndex = $select.val();

			var $rowToClone = $('.calculator__blank-data .categories__body > .category').eq(dataRowIndex);

			if ( $rowToClone.length > 0 ) {
				var $clonedRow = $rowToClone.clone();

				var $insertInto = $('.calculator__form .categories__body');

				$insertInto.append($clonedRow);

				update_calc_prices_r();
				update_calc_input_names_r();

				initializeSortables($clonedRow.find('.js-category-items'));

				// Save the current state.
				calc_state_save();
			}
		});
    }

    function selectColumn() {
		$body.on('change', '.js-select', function(e) {
            var $this = $(this);

			var val = $this.val();
			var $parent = $this.closest('.js-select-row');
			var target = $parent.find('[data-col=' + val + ']');

			if (target) {
				var $options = $this.find('option');

				$options.each(function(index, el) {
					var $el = $(el);
					var targetEl = $parent.find(
						'[data-col=' + $el.val() + ']'
					);

					if (targetEl) {
						$(targetEl).hide();
					}
				});

				$(target).show();
			}
        });
    }

    function categoryDropdowns() {
		$body.on('click', '.js-expand-dropdown', function(e) {
			e.preventDefault();

            var $this = $(this);
			var $dropdown = $this
				.closest('.js-col-dropdown')
				.find('.js-category-dropdown');
			var $category = $this.closest('.category');

			$this.toggleClass('is-active');

			var dropdownHeight = $dropdown.outerHeight();

			$dropdown.toggleClass('is-active');

			if ($dropdown.hasClass('is-active')) {
				$category
					.find('.js-category-bg')
					.addClass('is-active')
					.height(dropdownHeight);
			} else {
				$category
					.find('.js-category-bg')
					.removeClass('is-active')
					.height(0);
			}

			$this
				.parents('.category__col')
				.eq(0)
				.siblings()
				.find('.js-category-dropdown')
				.removeClass('is-active');

			$this
				.parents('.category__col')
				.eq(0)
				.siblings()
				.find('.js-expand-dropdown')
				.removeClass('is-active');
		});

		$body.on('click', '.js-category-dropdown ul li a', function(e) {
			e.preventDefault();

            var $this = $(this);
			var value = $this.text();

			var $category = $this.closest('.category');
			var $category_col = $this.closest('.js-col-dropdown');
			var $dropDown = $this.closest('.js-category-dropdown');
			var $input = $category_col.find('.js-dropdown-input');

			$category_col
				.find('.category__title .category__text')
				.text(value);

			$input.val(value);

			$category_col
				.find('.js-expand-dropdown')
				.removeClass('is-active');

			$dropDown
				.removeClass('is-active');

			$category
				.find('> .js-category-bg')
				.removeClass('is-active')
				.height(0);

			// Save the current state.
			calc_state_save();
        });

		$body.on('click', '.js-submit-dropdown', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $input = $this.siblings('.js-dropdown-input');
			var $inputVal = $input.val();
			var $category = $this.closest('.category');
			var $category_col = $this.closest('.js-col-dropdown');
			var $dropDown = $this.closest('.js-category-dropdown');

			$category_col
				.find('.category__title .category__text')
				.text($inputVal);

			$category_col
				.find('.js-expand-dropdown')
				.removeClass('is-active');

			$dropDown
				.removeClass('is-active');

			$category
				.find('> .js-category-bg')
				.removeClass('is-active')
				.height(0);

			// Save the current state.
			calc_state_save();
		});
    }

	function initializeSortables( items ) {
		var maxDepth     = 2;
		var draggedDepth = 0;

        for (var i = 0; i < items.length; i++) {
			$(items[i]).addClass('sort-initialized');

			// Docs: https://github.com/SortableJS/Sortable
            new Sortable(items[i], {
                group: {
					name: 'category-items',
					pull: function (to, from, dragEl, evt) {
						var toLvl = $(to.el).parents('.js-category-items').length + draggedDepth;

						if ( toLvl > maxDepth ) {
							return false;
						}

						return true;
					},
				},
                handle: '.js-handler',
                animation: 150,
                fallbackOnBody: true,
                swapThreshold: 0.65,
                filter: '.disable',
				preventOnFilter: false,
				delay: 0,
				delayOnTouchOnly: false,
				touchStartThreshold: 0,
				onMove: function (evt, originalEvent) {
					draggedDepth = $(evt.dragged).find('.js-category-items:has(.category)').length;
                },
				onEnd: function (evt) {
					// console.log(evt);

					var $to            = $(evt.to),
						$from          = $(evt.from),
						toChildCount   = $to.children().length,
						fromChildCount = $from.children().length;

					if ( toChildCount > 0 ) {
						var $cat          = $to.parents('.category').eq(0),
							$cat_expand   = $cat.find('> .category__cols .category__expand'),
							$expand_input = $cat_expand.find('input');

						$cat.addClass('is-active');
						$cat.removeClass('no-children');

						if ( toChildCount < 2 ) {
							$cat.find('> .category__cols .toggle_with_children').toggleClass('hidden');
						}

						$expand_input.prop('checked', true);
					}

					if ( fromChildCount < 1 ) {
						var $cat          = $from.parents('.category').eq(0),
							$cat_expand   = $cat.find('> .category__cols .category__expand'),
							$expand_input = $cat_expand.find('input');

						$cat.removeClass('is-active');
						$cat.addClass('no-children');
						$cat.find('> .category__cols .toggle_with_children').toggleClass('hidden');

						$expand_input.prop('checked', false);
					}

					update_calc_input_names_r();
					update_calc_prices_r();

					// Save the current state.
					calc_state_save();
				},
				// store: {
				// 	get: function (sortable) {
				// 		var order = localStorage.getItem(sortable.options.group.name);
				// 		return order ? order.split('|') : [];
				// 	},

				// 	set: function (sortable) {
				// 		var order = sortable.toArray();
				// 		localStorage.setItem(sortable.options.group.name, order.join('|'));
				// 	}
				// }
            });
        }
	}

    function colsHeight() {
        // var colsHeight = $('.category--alt .category__cols').outerHeight();
        // var fisrtColHeight = $('.js-col').outerHeight();
		
        // $('.js-expand-cols').on('click', function(e) {
        //     e.preventDefault();
        //     $(this).toggleClass('is-active');

        //     if ($(this).hasClass('is-active')) {
        //         $('.category--alt .category__cols').height(colsHeight);
        //     } else {
        //         $('.category--alt .category__cols').height(fisrtColHeight);
        //     }
        // });
    }

    function popupTrigger() {
		$body.on('click', '.js-cols-popup', function(e) {
            e.preventDefault();

			var $src_el = $(e.originalEvent.srcElement);

			if ( ! $src_el.closest('.list-category-actions').length ) {
				var $this = $(this);
				var $category = $this.parents('.category');
				var $popup = $category.find('> .js-popup-category');

				$popup.addClass('is-active');
				$category.addClass('is-popup-visible');

				$('body').addClass('is-fixed');
			}
        });

		$body.on('click', '.js-close-popup', function(e) {
            e.preventDefault();

			var $this = $(this);
			var $category = $this.parents('.category');
			var $popup = $category.find('> .js-popup-category');

            $popup.removeClass('is-active');
            $category.removeClass('is-popup-visible');

            $('body').removeClass('is-fixed');
        });

        $('.js-dropdown-controls').slideUp();

		$body.on('click', '.js-expand-field', function(e) {
            var $this = $(this);

            $this.off().on('click', function(e) {
                e.preventDefault();
                $this
                    .toggleClass('is-active')
                    .parents('.popup__controls')
                    .eq(0)
                    .find('.js-dropdown-controls')
                    .slideToggle();
            });
        });

        $('.js-dropdown-controls').each(function(index, el) {
            var $this = $(this);

			$this.find('ul li a').on('click', function(e) {
				e.preventDefault();

				var value = $(this).text();

				var $popup__controls = $(this).closest('.popup__controls');
				var $dropdown_controls = $popup__controls.find('.js-dropdown-controls');
				var $expand_btn = $popup__controls.find('.js-expand-field');

				$popup__controls.find('.js-field-text').text( value );
				$popup__controls.find('.js-popup-dropdown-input').val( value );

				$dropdown_controls.slideToggle();

				$expand_btn.toggleClass('is-active');
			});

            $this.find('.js-popup-submit-dropdown').on('click', function(e) {
                e.preventDefault();

                var inputVal = $(this)
                    .siblings()
                    .val();

				var $popup__controls = $(this).closest('.popup__controls');
				var $dropdown_controls = $popup__controls.find('.js-dropdown-controls');
				var $expand_btn = $popup__controls.find('.js-expand-field');

				$popup__controls.find('.js-field-text').text( inputVal );

				$dropdown_controls.slideToggle();

				$expand_btn.toggleClass('is-active');
            });
        });

        $('.js-submit-popup').on('click', function(e) {
            e.preventDefault();

			var $this = $(this);
			var $popup = $this.parents('.js-popup-category').eq(0);

            $popup.removeClass('is-active');

			$this
                .parents('.category')
				.removeClass('is-popup-visible');

            $('body').removeClass('is-fixed');

            var $fieldStaff = $popup.find('.js-field-staff')
                .find('input')
                .val();

            var $fieldPosition = $popup.find('.js-field-position')
                .find('input')
                .val();

            var $fieldEmp = $popup.find('.js-field-employment')
                .find('.js-field-text')
                .text();

            var $fieldDep = $popup.find('.js-field-department')
                .find('.js-field-text')
                .text();

            var $fieldSalary = $popup.find('.js-field-salary')
                .find('input')
                .val();

            var $fieldSuper = $popup.find('.js-field-super')
                .find('input')
                .val();

            var $categoryCols = $(this)
                .parents('.category__popup')
				.eq(0)
                .siblings('.category__cols');

            $categoryCols.find('.js-col-staff .js-text').text( $fieldStaff );
            $categoryCols.find('.js-col-staff .js-input').val( $fieldStaff );

            $categoryCols.find('.js-col-position .js-text').text( $fieldPosition );
            $categoryCols.find('.js-col-position .js-input').val( $fieldPosition );

            $categoryCols.find('.js-col-employment .js-text-dropdown').text( $fieldEmp );
            $categoryCols.find('.js-col-employment .js-dropdown-input').val( $fieldEmp );

            $categoryCols.find('.js-col-department .js-text-dropdown').text( $fieldDep );
            $categoryCols.find('.js-col-department .js-dropdown-input').val( $fieldDep );

            $categoryCols.find('.js-col-salary .js-text .money-value').text( formatMoneyVal( $fieldSalary ) );
            $categoryCols.find('.js-col-salary .js-input').val( formatMoneyVal( $fieldSalary, false ) );

            $categoryCols.find('.js-col-super .js-text .money-value').text( formatMoneyVal( $fieldSuper ) );
            $categoryCols.find('.js-col-super .js-input').val( formatMoneyVal( $fieldSuper, false ) );

			update_calc_prices_r();

			// Save the current state.
			calc_state_save();
        });
    }

	function calcGlobals() {
		$body.on('change', '.js-update-global', function(e) {
			window.calcOptions = window.calcOptions || {};

			var $this = $(this),
				name  = $this.attr('name'),
				type  = $this.attr('type'),
				val   = $this.val();

			if ( type === 'number' ) {
				if ( val === '' ) {
					val = $this.attr('data-default-val');
				} else if ( val === '0' ) {
					val = $this.attr('data-default-val');

					$this.val(val);
				}

				val = parseFloat( val );
			} else if ( type === 'checkbox' ) {
				val = $this.prop( 'checked' ) ? true : false;
			}

			// Check if property exists before updating value.
			// We shouldn't be adding new properties here.
			// window.calcOptions is defined in calc footer template.
			if ( window.calcOptions.hasOwnProperty( name ) ) {
				window.calcOptions[ name ] = val;
			}

			if ( $this.hasClass( 'js-toggle-super' ) ) {
				toggleSuper();
				// re_calc_super_from_salary();
			}

			// Update totals.
			update_calc_prices_r();

			// Save the current state.
			calc_state_save();
		});
    }

	function toggleSuper() {
		$('.calculator__form .categories__body').toggleClass('section-calculator--international');
    }

	function re_calc_super_from_salary() {
		$('.calculator__form .category__col[data-col="salary"] input').each(function() {
			update_calc_row_money( $(this) );
		});
	}

	function createCookie(name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	function checkCookie( $cookie_id ) {
		return readCookie( $cookie_id ) !== null ? true : false;
	}

	function auto_popup_init() {
		var $auto_load_popups = $('.popup--open-on-load');

		$auto_load_popups.each(function() {
			var $this = $(this);

			if ( ! $this.hasClass( 'popup--show-all' ) ) {
				if ( isMobile() && ! $this.hasClass( 'popup--show-mobile' ) ) {
					return;
				} else if ( isTablet() && ! isMobile() && ! $this.hasClass( 'popup--show-tablet' ) ) {
					return;
				} else if ( ! isTablet() && ! isMobile() ) {
					return;
				}
			}

			if ( $this.hasClass( 'popup--check-cookie' ) && checkCookie( $this.attr( 'data-popup-identifier' ) ) ) {
				return;
			}

			$.magnificPopup.open({
				items: {
					src: '#' + $(this).attr('id'),
					type: 'inline',
				},
				modal: true,
			});
		});
	}

    $win.on('load resize', function() {
        changeBackgroundImage();
        $('.contact .contact__content').equalizeHeight();
        $('.box').equalizeHeight();
        /*$('.js-resource-large').equalizeHeight();
        $('.js-resource').equalizeHeight();*/

		// if (isTablet()) {
		// 	$('.plan .plan__inner').equalizeHeight();
		// } else {
		// 	$('.plan .plan__inner').equalizeHeight( true );
		// }

        if (isTablet() || isMobile()) {
            colsHeight();
            popupTrigger();
            $('.features .features__item').equalizeHeight();
            $('.feature .feature__icon').equalizeHeight();
        } else {
            $('.features .features__item').equalizeHeight( true );
            $('.feature .feature__icon').equalizeHeight( true );
		}
    });

	$win.on('resize', function(e) {
        initializeSliders();
    });

    $doc.on('scroll', function(e) {
        winST = $win.scrollTop();
        animateHeader(winST);
		fixed_calc_header(winST);
    });

	$win.on('load', function(e) {
        winST = $win.scrollTop();
        animateHeader(winST);
		fixed_calc_header(winST);

		auto_popup_init();
    });

    $doc.ready(function() {
        videoPopup();
        modalPopup();
        fixedHeader();
		anchorLinks();
        initializeSliders();

        $('.js-year').html(new Date().getFullYear());

        AOS.init({
            once: true,
            delay: 200,
            duration: 800,
            offset: 100,
        });

		// If account page.
		if ( $body.hasClass('page-template-account') ) {
			widgetSwipe();
			create_calc();
			trash_calc();
			duplicate_calc();
		}

		// If calculator page.
		if ( $('.calculator__form').length ) {
			categorySwipe();
			textEdit();
			disableCategory();
			deleteCategory();
			expandCategory();
			cloneElement();
			addRow();
			addSibling();
			selectColumn();
			submitCalcFormHandler();
			download_calc();
			fixed_calc_header();
			calcGlobals();

			var items = $('.calculator__form .js-category-items');
			if ( items.length > 0 ) {
				initializeSortables(items);
			}

			categoryDropdowns();

			calc_history_init();
		}

        if ($win.width() < 768) {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty(
                '--vh',
                ''.concat(vh, 'px')
            );
        }

		if ( $('.js-membership-toggle').length ) {
			$('.js-membership-toggle').on('click', function(e) {
				var $this = $(this),
					$checkbox = $this.find('.toggle-button-checkbox'),
					$checked = $this.find('.toggle-button-label__checked'),
					$unchecked = $this.find('.toggle-button-label__unchecked'),
					$link = $this.closest('.plan').find('.js-membership-toggle-link');

				if ( $checkbox.prop('checked') ) {
					$link.attr('href', $checked.data('membership-url'));
				} else {
					$link.attr('href', $unchecked.data('membership-url'));
				}
			});
		}

		$('.js-membership-select').on('change', function() {
			var $this = $(this),
				url   = $this.val(),
				$target = $($this.attr('data-target'));

			if ( $target.length ) {
				$target.attr('href', url);
			}
		});

		$('.efront_custom_mp_form .mepr_custom_field').each(function() {
			var $label = $(this).find('.mp-form-label label'),
				$input = $(this).find('.mepr-form-input');

			$input.attr('placeholder', $label.text() );
		});
    });

    $(document).on('mobileinit', function() {
        $.mobile.ignoreContentEnabled = true;
    });

	function update_calc_input_names_r( $calc_rows, level_r, current_name_prefix ) {
		if ( typeof $calc_rows === 'undefined' ) {
			$calc_rows = $( '.calculator__form .categories__body > .category' );
		}

		if ( typeof level_r === 'undefined' ) {
			level_r = 0;
		}

		if ( typeof current_name_prefix === 'undefined' ) {
			current_name_prefix = 'calc_data';
		}

		if ( level_r === 0 ) {
			// console.log('Updating calculator input name structure.');
		}

		$calc_rows.each(function(row_index, row) {
			var $row = $(row),
				$sub_rows = $row.find('> .category__subitems > .category'),
				row_name_prefix = current_name_prefix + '[' + row_index + ']';

			$row.find('> input, > .category__cols input').each(function(input_index, input) {
				var $input = $(input),
					input_name = $input.attr('data-input-name');

				$input.attr('name', row_name_prefix + input_name);

				if ( $input.hasClass('js-totals') ) {
					$input.prop('readonly', $sub_rows.length > 0 );
				}
			});

			if ( $sub_rows.length ) {
				update_calc_input_names_r( $sub_rows, level_r + 1, row_name_prefix + '[category]' );
			}
		});

		if ( level_r === 0 ) {
			// Save calculator in background.
			save_calc( true );
		}

		return true;
	}

	function update_calc_prices_r( $calc_rows, level_r, totals ) {
		if ( typeof $calc_rows === 'undefined' ) {
			$calc_rows = $( '.calculator__form .categories__body > .category' );
		}

		if ( typeof level_r === 'undefined' ) {
			level_r = 0;
		}

		if ( level_r === 0 ) {
			// console.log('Updating calculator price totals.');
		} else {
			var row_totals = {
				'weekly'  : 0,
				'monthly' : 0,
				'yearly'  : 0,
			};
		}

		if ( typeof totals === 'undefined' ) {
			totals = {
				'weekly'  : 0,
				'monthly' : 0,
				'yearly'  : 0,
			};
		}

		$calc_rows.each(function(row_index, row) {
			var $row = $(row);
			var $sub_rows = $row.find('> .category__subitems > .category');

			if ( $sub_rows.length ) {
				$child_totals = update_calc_prices_r( $sub_rows, level_r + 1, totals );

				$row.find('> .category__cols [data-col="weekly"] .js-text .money-value').text( formatMoneyVal( $child_totals['weekly'] ) );
				$row.find('> .category__cols [data-col="monthly"] .js-text .money-value').text( formatMoneyVal( $child_totals['monthly'] ) );
				$row.find('> .category__cols [data-col="yearly"] .js-text .money-value').text( formatMoneyVal( $child_totals['yearly'] ) );

				$row.find('> .category__cols [data-col="weekly"] .js-totals').val( formatMoneyVal( $child_totals['weekly'], false ) );
				$row.find('> .category__cols [data-col="monthly"] .js-totals').val( formatMoneyVal( $child_totals['monthly'], false ) );
				$row.find('> .category__cols [data-col="yearly"] .js-totals').val( formatMoneyVal( $child_totals['yearly'], false ) );

			} else if ( $row.closest('.category.disable').length === 0 ) {
				if ( $row.is('[data-row-type="staff"]') ) {
					var yearly_total = parseFloat( $row.find('> .category__cols [data-col="salary"] .js-totals').val() );

					if ( ! $('.calculator__form .section-calculator--international').length ) {
						var super_value = parseFloat( $row.find('> .category__cols [data-col="super"] .js-totals').val() );

						yearly_total = yearly_total + super_value;
					}
				} else {
					var yearly_total = parseFloat( $row.find('> .category__cols [data-col="yearly"] .js-totals').val() );
				}

				var monthly_total = yearly_total / num_of_months_in_business_period(),
					weekly_total  = monthly_total / num_of_weeks_in_month();

				totals['weekly']  = parseFloat( totals['weekly'] ) + weekly_total;
				totals['monthly'] = parseFloat( totals['monthly'] ) + monthly_total;
				totals['yearly']  = parseFloat( totals['yearly'] ) + yearly_total;
			}

			if ( level_r > 0 && ! $row.hasClass('disable') ) {
				if ( $row.is('[data-row-type="staff"]') ) {
					var yearly_total = parseFloat( $row.find('> .category__cols [data-col="salary"] .js-totals').val() );

					if ( ! $('.calculator__form .section-calculator--international').length ) {
						var super_value = parseFloat( $row.find('> .category__cols [data-col="super"] .js-totals').val() );

						yearly_total = yearly_total + super_value;
					}
				} else {
					var yearly_total = parseFloat( $row.find('> .category__cols [data-col="yearly"] .js-totals').val() );
				}

				var monthly_total = yearly_total / num_of_months_in_business_period( false ),
					weekly_total  = monthly_total / num_of_weeks_in_month();

				row_totals['weekly']  = parseFloat( row_totals['weekly'] ) + weekly_total;
				row_totals['monthly'] = parseFloat( row_totals['monthly'] ) + monthly_total;
				row_totals['yearly']  = parseFloat( row_totals['yearly'] ) + yearly_total;
			}
		});

		if ( level_r === 0 ) {
			totals['daily']  = parseFloat( totals['weekly'] ) / 7;
			totals['hourly'] = totals['daily'] / num_of_hours_worked();

			// Updating calculator footer totals.
			$('.calc_totals_hourly .money-value').text( formatMoneyVal( totals['hourly'] ) );
			$('.calc_totals_daily .money-value').text( formatMoneyVal( totals['daily'] ) );
			$('.calc_totals_weekly .money-value').text( formatMoneyVal( totals['weekly'] ) );
			$('.calc_totals_monthly .money-value').text( formatMoneyVal( totals['monthly'] ) );
			$('.calc_totals_yearly .money-value').text( formatMoneyVal( totals['yearly'] ) );

			// Updating hidden calculator total inputs.
			$('.calc_totals_hourly_input').val( formatMoneyVal( totals['hourly'], false ) );
			$('.calc_totals_daily_input').val( formatMoneyVal( totals['daily'], false ) );
			$('.calc_totals_weekly_input').val( formatMoneyVal( totals['weekly'], false ) );
			$('.calc_totals_monthly_input').val( formatMoneyVal( totals['monthly'], false ) );
			$('.calc_totals_yearly_input').val( formatMoneyVal( totals['yearly'], false ) );

			// Update per person/team totals if this is a COB calculator.
			if ( $body.hasClass('ct_calculator_type-business-expenses') ) {
				// Updating per billable person/team totals

				var num_of_people = get_num_of_billable_people();

				var per_person_hourly  = totals['hourly'] / num_of_people;
				var per_person_daily   = totals['daily'] / num_of_people;
				var per_person_weekly  = totals['weekly'] / num_of_people;
				var per_person_monthly = totals['monthly'] / num_of_people;
				var per_person_yearly  = totals['yearly'] / num_of_people;

				$('.calc_totals_billable_hourly .money-value').text( formatMoneyVal( per_person_hourly ) );
				$('.calc_totals_billable_daily .money-value').text( formatMoneyVal( per_person_daily ) );
				$('.calc_totals_billable_weekly .money-value').text( formatMoneyVal( per_person_weekly ) );
				$('.calc_totals_billable_monthly .money-value').text( formatMoneyVal( per_person_monthly ) );
				$('.calc_totals_billable_yearly .money-value').text( formatMoneyVal( per_person_yearly ) );

				// Updating hidden calculator total inputs.
				$('.calc_totals_billable_hourly_input').val( formatMoneyVal( per_person_hourly, false ) );
				$('.calc_totals_billable_daily_input').val( formatMoneyVal( per_person_daily, false ) );
				$('.calc_totals_billable_weekly_input').val( formatMoneyVal( per_person_weekly, false ) );
				$('.calc_totals_billable_monthly_input').val( formatMoneyVal( per_person_monthly, false ) );
				$('.calc_totals_billable_yearly_input').val( formatMoneyVal( per_person_yearly, false ) );
			}

			// Save calculator in background.
			save_calc( true );
		} else {
			return row_totals;
		}
	}

	function update_calc_row_money( $updated_input ) {
		var $row_cols = $updated_input.parents('.category__cols').eq(0);

		// Calculate super if edited field is the salary value.
		if ( $updated_input.hasClass('js-totals-salary') ) {
			var salary_val = parseFloat( $updated_input.val() ),
				super_val  = salary_val * get_super_rate();

			$row_cols.find('[data-col="super"] input.js-totals-super').val( formatMoneyVal( super_val, false ) );
			$row_cols.find('[data-col="super"] .js-text .money-value').text( formatMoneyVal( super_val ) );

			return true;
		}

		// Calculate salary if edited field is the super value.
		if ( $updated_input.hasClass('js-totals-super') ) {
			// var super_val  = parseFloat( $updated_input.val() ),
			// 	salary_val = super_val / get_super_rate();

			// $row_cols.find('[data-col="salary"] input.js-totals-salary').val( formatMoneyVal( salary_val, false ) );
			// $row_cols.find('[data-col="salary"] .js-text .money-value').text( formatMoneyVal( salary_val ) );

			return true;
		}

		var update_week = update_month = update_year = false;

		if ( $updated_input.hasClass('js-totals-weekly') ) {
			var weekly_val  = parseFloat( $updated_input.val() ),
				monthly_val = weekly_val * num_of_weeks_in_month(),
				yearly_val  = monthly_val * num_of_months_in_business_period( false );

			update_month = update_year = true;
		} else if ( $updated_input.hasClass('js-totals-monthly') ) {
			var monthly_val = parseFloat( $updated_input.val() ),
				weekly_val  = monthly_val / num_of_weeks_in_month(),
				yearly_val  = monthly_val * num_of_months_in_business_period( false );

			update_week = update_year = true;
		} else if ( $updated_input.hasClass('js-totals-yearly') ) {
			var yearly_val  = parseFloat( $updated_input.val() ),
				monthly_val = yearly_val / num_of_months_in_business_period( false );
				weekly_val  = monthly_val / num_of_weeks_in_month(),

			update_week = update_month = true;
		} else {
			return false;
		}

		if ( update_week ) {
			$row_cols.find('[data-col="weekly"] input.js-totals-weekly').val( formatMoneyVal( weekly_val, false ) );
			$row_cols.find('[data-col="weekly"] .js-text .money-value').text( formatMoneyVal( weekly_val ) );
		}

		if ( update_month ) {
			$row_cols.find('[data-col="monthly"] input.js-totals-monthly').val( formatMoneyVal( monthly_val, false ) );
			$row_cols.find('[data-col="monthly"] .js-text .money-value').text( formatMoneyVal( monthly_val ) );
		}

		if ( update_year ) {
			$row_cols.find('[data-col="yearly"] input.js-totals-yearly').val( formatMoneyVal( yearly_val, false ) );
			$row_cols.find('[data-col="yearly"] .js-text .money-value').text( formatMoneyVal( yearly_val ) );
		}
	}

	// Get the number of months that the business operates. Pass along var to use/not use user defined value (default true).
	function num_of_months_in_business_period( $use_user_value ) {
		$use_user_value = typeof $use_user_value !== 'undefined' ? $use_user_value : true;

		return num_of_business_days_worked( $use_user_value ) / ( 365 / 12 );
	}

	// Get the number of weeks that the business operates. Pass along var to use/not use user defined value (default true).
	function num_of_weeks_in_business_period( $use_user_value ) {
		$use_user_value = typeof $use_user_value !== 'undefined' ? $use_user_value : true;

		return num_of_business_days_worked( $use_user_value ) / 7;
	}

	// Get the number of days a year the business operates. Or default (365 days) if not using user defined value or not defined (default true).
	function num_of_business_days_worked( $use_user_value ) {
		$use_user_value = typeof $use_user_value !== 'undefined' ? $use_user_value : true;

		return $use_user_value && window.calcOptions && window.calcOptions.number_of_business_days || 365;
	}

	// Get the number of billable hours. Or default (8 hours) if not defined.
	function num_of_hours_worked( $use_user_value ) {
		$use_user_value = typeof $use_user_value !== 'undefined' ? $use_user_value : true;

		return $use_user_value && window.calcOptions && window.calcOptions.number_of_billable_hours || 8;
	}

	// Get the number of weeks in a month. Clients originally wanted to use avg 4 weeks/month but has changed their mind. I am shooketh!
	function num_of_weeks_in_month() {
		return 52 / 12;
	}

	// Get super rate global or default (0.1 = 10%) if not defined.
	function get_super_rate() {
		return window.calcOptions && window.calcOptions.super_rate || 0.1;
	}

	// Get the number of billable people or default (1 person) if not defined.
	function get_num_of_billable_people() {
		return window.calcOptions && window.calcOptions.number_of_billable_people || 1;
	}

	function formatMoneyVal( value, include_separators ) {
		if ( typeof include_separators === 'undefined' ) {
			include_separators = true;
		}

		if ( value === '' || ( typeof value === 'number' && value !== value ) ) { // If value is '' or NaN.
			value = 0.00;
		}

		if ( typeof value === 'string' ) {
			value = value.replace( /[$,]*/g, '' );
		}

		value = parseFloat( value );

		var formatted = value.toLocaleString(
			'nu', {
				style: 'decimal',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				useGrouping: include_separators,
			}
		);

		formatted = formatted.replace( '.00', '' );

		return formatted;
	}

	function submitCalcFormHandler() {
		$('.calculator__form').on('submit', function(e) {
			e.preventDefault();

			save_calc();
		});
	}

	var save_request;

	function save_calc( save_in_background, trigger_download_url ) {
		if ( typeof save_in_background === 'undefined' ) {
			save_in_background = false;
		}

		if ( typeof trigger_download_url === 'undefined' ) {
			trigger_download_url = false;
		}

		var form_data = $('.calculator__form').serializeArray();

		form_data.push({
			name: 'action',
			value: 'efront_calculator_ajax_save',
		});

		var user_action = 'auto_save';

		if ( ! save_in_background ) {
			$body.addClass('ajax-loading');

			var user_action = 'manual_save';
		}

		form_data.push({
			name: 'user_action',
			value: user_action,
		});

		// Abort any existing (in progress) save requests.
		if ( save_request ) {
			save_request.abort();
		}

		save_request = $.post(
			window.ajax_url,
			form_data,
			function(response) {
				// console.log(response);

				if ( ! save_in_background ) {
					$body.removeClass('ajax-loading');
				}

				if ( trigger_download_url ) {
					window.location = trigger_download_url;
				}
			}
		);
	}

	function create_calc() {
		$body.on('click', '.js-create-calc', function(e) {
			e.preventDefault();

			var $this   = $(this),
				type_id = $this.attr('data-type-id');

			var data = {
				action: 'efront_calculator_ajax_create',
				efront_calculator_ajax_create_nonce: window.calc_nonces.create,
				type_id: type_id,
			};

			if ( typeof type_id !== "undefined" ) {
				$body.addClass('ajax-loading');

				$.post(
					window.ajax_url,
					data,
					function(response) {
						// console.log(response);

						if ( typeof response.status !== 'undefined' ) {
							if ( response.status ) {

								if ( typeof response.data !== 'undefined' ) {
									var $widgets = $('.widgets[data-calc-type-id="' + type_id + '"]');
									var $section = $widgets.closest('section');
									var $top_item = $widgets.find('.widget').eq(0);

									if ( $top_item.length ) {
										$top_item.before( response.data );
									} else {
										$widgets.append( response.data );
									}

									$added_calc = $widgets.find('.widget.widget--ajax');

									// Attach trash popup event handler within new calc item.
									trash_calc_popup_init( $added_calc );

									if ( $section.is(':hidden') ) {
										$section.fadeIn();
									}

									$('html, body').animate({
										scrollTop: $section.offset().top,
									}, 400, function() {
										$added_calc.fadeIn(function() {
											$(this).removeClass('widget--ajax');
											AOS.refresh();
										});
									});
								} else {
									// Error - Missing response.data.
								}
							} else {
								if ( typeof response.error_reason !== 'undefined' && response.error_reason === 'limit' ) {
									$.magnificPopup.open({
										items: {
											src: '#limit-modal',
											type: 'inline',
										},
										modal: true,
									});
								}
							}
						} else {
							// Error - response.status = undefined.
						}

						$body.removeClass('ajax-loading');
					}
				);
			}
		});
	}

	// Attach magnificPopup to trash buttons within $parent (used on page load and on calc creation/duplication).
	function trash_calc_popup_init( $parent ) {
		$parent = typeof $parent !== 'undefined' ? $parent : $body;

		$parent.find('.js-popup-modal-delete').each(function(index, el) {
            $(this).magnificPopup({
                type: 'inline',
                preloader: false,
                modal: true,
				callbacks: {
					open: function() {
						var calc_id    = this.ev.attr('data-calc-id'),
							popup_html = this.content;

						popup_html.find('.js-trash-calc').attr('data-calc-id', calc_id);
					},
				},
            });
        });
	}

	function trash_calc() {
		trash_calc_popup_init();

		$body.on('click', '.js-trash-calc', function(e) {
			e.preventDefault();

			var $this      = $(this),
				calc_id    = $this.attr('data-calc-id'),
				$calc_row  = $('.section-calc-list .widget[data-calc-id="' + calc_id + '"]'),
				$section   = $calc_row.closest('section'),
				$calc_rows = $calc_row.closest('.widgets');

			var data = {
				action: 'efront_calculator_ajax_trash',
				efront_calculator_ajax_trash_nonce: window.calc_nonces.trash,
				calc_id: calc_id,
			};

			if ( typeof calc_id !== "undefined" ) {
				$body.addClass('ajax-loading');

				$.post(
					window.ajax_url,
					data,
					function(response) {
						// console.log(response);

						if ( typeof response.status !== 'undefined' && response.status ) {
							if ( $calc_rows.find('.widget').length > 1 ) {
								$calc_row.remove();
								AOS.refresh();
							} else {
								$section.fadeOut(function() {
									$calc_row.remove();
									AOS.refresh();
								});
							}
						} else {
							// Error - response.status = false or is undefined.
						}

						$body.removeClass('ajax-loading');
					}
				);
			}
		});
	}

	function duplicate_calc() {
		$body.on('click', '.js-duplicate-calc', function(e) {
			e.preventDefault();

			var $this      = $(this),
				calc_id    = $this.attr('data-calc-id'),
				$calc_row  = $('.section-calc-list .widget[data-calc-id="' + calc_id + '"]'),
				$calc_rows = $calc_row.closest('.widgets');

			var data = {
				action: 'efront_calculator_ajax_duplicate',
				efront_calculator_ajax_duplicate_nonce: window.calc_nonces.duplicate,
				calc_id: calc_id
			};

			if ( typeof calc_id !== "undefined" ) {
				$body.addClass('ajax-loading');

				$.post(
					window.ajax_url,
					data,
					function(response) {
						// console.log(response);

						if ( typeof response.status !== 'undefined' && response.status ) {
							if ( typeof response.data !== 'undefined' ) {
								var $section  = $calc_rows.closest('section');
								var $top_item = $calc_rows.find('.widget').eq(0);

								if ( $top_item.length ) {
									$top_item.before( response.data );
								} else {
									$calc_rows.append( response.data );
								}

								$added_calc = $calc_rows.find('.widget.widget--ajax');

								// Attach trash popup event handler within new calc item.
								trash_calc_popup_init( $added_calc );

								if ( $section.is(':hidden') ) {
									$section.fadeIn();
								}

								$calc_row.removeClass( 'is-active' );

								$('html, body').animate({
									scrollTop: $section.offset().top,
								}, 400, function() {
									$added_calc.fadeIn(function() {
										$(this).removeClass('widget--ajax');
										AOS.refresh();
									});
								});
							} else {
								// Error - Missing response.data.
							}
						} else {
							// Error - response.status = false or is undefined.
						}

						$body.removeClass('ajax-loading');
					}
				);
			}
		});
	}

	function download_calc() {
		$body.on('click', '.js-download-calc', function(e) {
			e.preventDefault();

			var $this      = $(this),
				calc_id    = $this.attr('data-calc-id');

			var data = {
				action: 'efront_calculator_ajax_download',
				efront_calculator_ajax_download_nonce: window.calc_nonces.download,
				calc_id: calc_id,
			};

			if ( typeof calc_id !== "undefined" ) {
				$('.popup#download-modal').find('.popup__close').trigger('click');

				var download_url = window.ajax_url + '?action=efront_calculator_ajax_download&efront_calculator_ajax_download_nonce=' + window.calc_nonces.download + '&calc_id=' + calc_id;

				save_calc( false, download_url );
			}
		});
	}

	// === Calc undo/redo functions. ===
	var	$history_enable = false,
		$undo_btn = $('.js-history-undo'),
		$redo_btn = $('.js-history-redo');
		window.stack     = {
			current_index: 0,
			states: [],
		};

	function calc_history_init() {
		$history_enable = true;

		$undo_btn.on('click', function(e) {
			e.preventDefault();

			calc_state_undo();
		});

		$redo_btn.on('click', function(e) {
			e.preventDefault();

			calc_state_redo();
		});

		calc_state_save();
	}

	function calc_state_save() {
		if ( ! $history_enable ) {
			return;
		}

		var $new_content = {
			calc_header: $('.calculator__form .section__head').clone( true ),
			calc_body: $('.calculator__form .categories__body').clone( true ),
			calc_options: $('.calculator__form .summary__row--options').clone( true ),
		}

		if ( stack.states.length !== 0 && stack.current_index !== stack.states.length - 1 ) {
			// Saving state after having previously undone changes.
			// Trim any states newer than current index and reduce the current index by 1.

			stack.states.splice( stack.current_index + 1 );
		}

		stack.current_index = stack.states.length === 0 ? 0 : stack.current_index + 1;
		stack.states.push( $new_content );

		calc_history_toggle_buttons();
	}

	function calc_state_undo() {
		if ( stack.current_index < 1 ) {
			// Already at oldest state.
			return;
		}

		calc_state_action( 'undo' );
	}

	function calc_state_redo() {
		if ( stack.current_index >= stack.states.length - 1 ) {
			// Already at newest state.
			return;
		}

		calc_state_action( 'redo' );
	}

	function calc_state_action($action) {
		var modifier = $action === 'undo' ? -1 : 1;

		var newState = stack.current_index + modifier;

		var $replaceWith = stack.states[ newState ];

		$('.calculator__form .section__head').replaceWith( $replaceWith.calc_header.clone( true ) );
		$('.calculator__form .categories__body').replaceWith( $replaceWith.calc_body.clone( true ) );
		$('.calculator__form .summary__row--options').replaceWith( $replaceWith.calc_options.clone( true ) );

		initializeSortables( $('.calculator__form .js-category-items') );

		stack.current_index = stack.current_index + modifier;

		calc_history_toggle_buttons();

		// Update totals.
		update_calc_prices_r();

		// Save calculator in background.
		save_calc( true );
	}

	function calc_history_toggle_buttons() {
		var undo_btn_enable = redo_btn_enable = false;

		if ( stack.current_index > 0 ) {
			undo_btn_enable = true;
		}

		if ( stack.current_index < stack.states.length - 1 ) {
			redo_btn_enable = true;
		}

		$undo_btn.toggleClass( 'disabled', ! undo_btn_enable );
		$redo_btn.toggleClass( 'disabled', ! redo_btn_enable );
	}
	// === END Calc undo/redo functions. ===
})(jQuery, window, document);
